module.exports = __webpack_public_path__ + "static/media/aayat_aakar.40e446ff.wav";